import { useId } from "react";

const useErrorMessage = (message: string | null | undefined) => {
  const id = useId();

  return message ? { message, id } : null;
};

export default useErrorMessage;
